package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_11_29_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("With Korvis’s help, the heroes transform into clouds and swiftly travel to The Wharf-Side Wicket Inn to see Prudence of The Barrowmen. Prudence admits that a Barrowman has gone missing (perhaps Ludwig Voss killed and impersonated him). She identifies the halfling that employed the Barrowmen to spy on the Friends of Forest as “Brock.” She presents her finding about Lord Thradoris Fox:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Outgoing")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Arrogent")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Gregarious")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Philanthropist")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("One of the premier paladins in the land")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Adventurer for 20 years")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("~40 years old")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Obsessed with jousting")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Follower of Entor")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Descendant of ancient kings")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Dorvidian empire lineage")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Untold riches")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Estate:")
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Purchased 7-8 years ago")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Physical and magical defense")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("River is a weak point in defenses but is heavily guarded")
                }
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes transform back into cloud form and quickly travel to the Fox estate. Caper takes the lead. At the entrance, Arthur greets the heroes and walks them to the main compound (about 20 minute walk). They enter a large roofless warehouse room. Lord Fox sits on a throne. The room also contains several training dummies and weapon racks.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Lord Fox offers the heroes a friendly greeting but admits that he’s never heard of The Friends of the Forest before. Caper butters him up —  expressing her interest in his amazing adventures. Fox wants to keep this meeting informal and asks the heroes to use his first name “Thradoris” rather than “Lord Fox.”")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday recounts the battle against the Blue Dragon Do’Shara — how The Friends of the Forest received the ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("boon of Entor")
        }
        org.jetbrains.compose.web.dom.Text(". Fox initially expresses some skepticism, but Falorn shows him a Blue Dragon claw.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Fox tells the heroes that he can’t show off his artifacts until the afternoon and invites the heroes to a banquet at 3pm. Arthur sees the heroes out through the East gate. Caper and Tuesday want to go to South Park to see if anyone is following them.")
    }
}
